<template>
  <div class="content_box" style="background-color: #f5f6fa">
    <hear></hear>

    <el-tabs  class="cion xiheng" tab-position="left">
      <el-tab-pane style="" class="fromsBoxs" label="消息详情">
        <div
          style="display: flex; justify-content: flex-end; margin-bottom: -60px"
        >
          <el-button class="anniu" @click="cionfan">返回</el-button>
        </div>
        <el-form
          :model="formdata"
          label-width="170px"
          :disabled="true"
          class="fromsBox"
        >
          <el-form-item label="消息编号 :">
            <el-input v-model="formdata.me_code" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="发送人 :">
            <el-input v-model="formdata.fs_name" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="发送人类型 :">
            <el-input
              v-if="formdata.fs_type == 1"
              value="申请方"
              autocomplete="off"
            ></el-input>
            <el-input v-else value="出函方" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="接收人姓名:">
            <el-input v-model="formdata.js_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="接收人类型:">
            <el-input
              v-if="formdata.js_type == 1"
              value="申请方"
              autocomplete="off"
            ></el-input>
            <el-input v-else value="出函方" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="消息标题:">
            <el-input v-model="formdata.title" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="消息内容:">
            <el-input
              v-model="formdata.content"
              type="textarea"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="消息类型:">
            <el-input
              v-if="formdata.type == 1"
              value="系统消息"
              autocomplete="off"
            ></el-input>
            <el-input v-else value="短信消息" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="发送时间:">
            <el-input
              :value="formdata.fs_time | dateFormat"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item v-show="formdata.state == 2" label="查看时间:">
            <el-input
              :value="formdata.ck_time | dateFormat"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态:">
            <!-- "state": 2, //保函状态，0：申请中，1：审核中，2：审核通过，3：审核不通过 -->
            <el-input
              v-show="formdata.state == 1"
              value="未查看"
              autocomplete="off"
            ></el-input>
            <el-input
              v-show="formdata.state == 2"
              value="已查看"
              autocomplete="off"
            ></el-input>
            <el-input
              v-show="formdata.state == 3"
              value="已删除"
              autocomplete="off"
            ></el-input>
            <!-- <el-input v-show="formdata.state == 3" value="审核不通过" autocomplete="off"></el-input> -->
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <binad></binad>
  </div>
</template>

<script>
import hear from "@/components/hear.vue";
import binad from ".././../components/dinad.vue";
import zhao from "@/view/biao/zhao.vue";
import zhaos from "@/view/biao/zhaos.vue";
import zhong from "@/view/biao/zhong.vue";
import zhongs from "@/view/biao/zhongs.vue";
import {
  kuaidi,
  ziliao,
  bhlist,
  bh_detail,
  fapiao,
  list,
  homepage,
  messageDel,
  password,
  logou,
  shenqingkaipiao,
} from "@/api/system/usercenter.js";
export default {
  components: {
    hear,
    // cioand,
    binad,
    zhong,
    zhao,
    zhaos,
    zhongs,
  },
  data() {
    return {
      tabPosition: "left",
      activeName: "first",
      // 快递参数
      kuaidi_params: {
        limit: 10,
        offset: 0,
      },
      // 快递总条数
      kuaidi_total: null,
      baohan_total: null,
      // 快递列表
      kuaidilist: [],
      jigouName: "",
      jigouNames: "",
      // 个人资料
      ziliaolist: {},
      labelPosition: "top",
      // 保函列表
      Bh_list: [],
      // 保函详情参数
      Bh_details: {
        offset: 0,
        limit: 10,
      },
      // 保函详情内容
      Bh_content: {},
      // 保函总条数
      Bh_total: null,
      // 发票参数
      fapiao_params: {
        offset: 0,
        limit: 10,
        keywords: "",
        // user_id: sessionStorage.getItem("user_id"),
      },
      baohan_params: {
        offset: 0,
        limit: 10,
        keywords: "",
        // user_id: sessionStorage.getItem("user_id"),
      },
      weidaili_search: "",
      // 发票总条数
      fapiao_total: null,
      // 发票列表容器
      fapiaolist: [],
      // 修改密码参数
      form: {
        password: "",
        old_password: "",
      },
      password_again: "",
      xiang: false,
      formdata: {},
      params: {
        type: "",
        keyWrod: "",
        page: 1,
        page_limit: 10,
        type: "",
      },
      tableData: [],
    };
  },
        created() {
console.log(this.$route.query)
    this.formdata=this.$route.query
    console.log(this.formdata)
  },
  mounted() {

    // this.getBhlist();
    // this.getBhdetail();
    // this.getFapiao();
    // this.getList();
  },
  methods: {
    // 获取快递列表
    shuaxin() {
      this.getList();
    },
    // 通知列表
    getList() {
      list({ ...this.params }).then((res) => {
        console.log(res.data);
        if (res.data.code == 1) {
          this.tableData = res.data.data.rows;
          this.total = res.data.data.total;
        }
      });
    },
    cionfan() {
     
        // this.xiang = false;
      this.$router.push({
      path: '/sNavbar',
      query: {
         id: "tong1"
       }
 })

    },
    handleSizeChange_baohan(val) {
      this.Bh_details.limit = val;
      this.getBhlist();
    },

    handleCurrentChange_baohan(val) {
      this.Bh_details.offset = parseInt(val - 1) * this.Bh_details.limit;
      this.getBhlist();
    },
    handleAdd() {
      console.log(123);
    },

    handleClick(e) {
      console.log(e);
      homepage({ me_code: e.me_code }).then((res) => {
        if ((res.data.code = 1)) {
          this.formdata = e;
          // this.formdata.ck_time=this.dateFormat(this.formdata.ck_time)
          // this.formdata.fs_time=this.dateFormat(this.formdata.fs_time)
          this.xiang = true;
          this.getList();
          //   this.$message({
          //   type: this.xiang,
          //   message: "成功!",
          // });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleClicks(e) {
      var taht = this;
      console.log(e);
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          messageDel({ me_code: e.me_code }).then((res) => {
            if (res.data.code == 1) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getList();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 获取保函列表
    getBhlist() {
      bhlist(this.Bh_details).then((res) => {
        if (res.data.code == 1) {
          this.Bh_list = res.data.data.rows;
          this.Bh_total = res.data.data.total;
        } else {
          this.$message.error("网络异常");
        }
      });
    },
    // 获取保函详情 点击详情按钮
    getBhdetail() {
      let bh_id = 1;
      bh_detail({ bh_id }).then((res) => {
        if (res.data.code == 1) {
          this.Bh_content = res.data.data.jiben;
        } else {
          this.$message.error("网络异常");
        }
      });
    },
    handleSizeChange_bh(val) {
      this.Bh_details.limit = val;
      this.getBhlist();
    },
    handleCurrentChange_bh(val) {
      this.Bh_details.offset = parseInt(val - 1) * 10;
      this.getBhlist();
    },
    // 获取发票列表
    getFapiao() {
      fapiao(this.fapiao_params).then((res) => {
        if (res.data.code == 1) {
          this.fapiaolist = res.data.data.rows;
          console.log("发票列表", this.fapiaolist);

          this.fapiao_total = res.data.data.total;
        } else {
          this.$message.error("网络异常");
        }
      });
    },
    // 申请发票
    handleshenqing(id) {
      shenqingkaipiao({ user_id: sessionStorage.getItem("user_id"), id }).then(
        (res) => {
          if (res.data.code == 1) {
            this.$message.success("申请成功");
            this.getFapiao();
          } else {
            this.$message.error(res.data.msg);
          }
        }
      );
    },
    handleSizeChange(val) {
      console.log("123");
      this.fapiao_params.limit = val;
      this.getFapiao();
    },
    handleCurrentChange(val) {
      console.log("1234");
      this.fapiao_params.offset = parseInt(val - 1) * 10;
      this.getFapiao();
    },
    handleSearch() {
      this.fapiao_params.keywords = this.weidaili_search;
      this.getFapiao();
    },
  },
};
</script>

<style >
.xiheng .el-tabs__content {
  height: 100%;
  overflow: auto;
}
</style>
<style scoped lang="scss">
.update_password {
  width: 100%;
  display: flex;
  justify-content: center;
  .update {
    width: 30%;
  }
}
::v-deep.el-form--inline .el-form-item {
  width: 100%;
}
::v-deep.el-form--inline .el-form-item__content {
  width: 100%;
}
.search {
  float: right;
  width: 20%;
  margin: 10px 0 10px 0;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
  display: flex;
  ::v-deep.el-input__inner {
    border: none !important;
  }
  .el-button {
    border: none;
  }
}
::v-deep.el-input__inner {
  border: none !important;
}
.block {
  float: right;
  padding-right: 20px;
  padding-top: 10px;
  // margin-top: 5vh;
}
::v-deep.el-tabs--left {
  // min-height: calc(100vh - 72px);
  height: 100%;
  .el-tabs__item.is-left {
    width: 200px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 18px;
    font-family: MicrosoftYaHei-, MicrosoftYaHei;
    font-weight: normal;
    color: #000000;
  }

  .el-tabs__item.is-active {
    background: #1795ff;
    color: #fff;
  }
}
.tacs {
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.content_box {
  height: 100%;
  //  min-height: calc(100vh + 155px);
  //  min-height: calc(100% + 155px);
  display: flex;
  flex-direction: column;
  .content {
    // margin: 0 auto;
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    // padding: 0 2%;
    margin-top: 3px;
    background-color: #fff;
    // min-height: calc(100vh - 72px);

    .card_father {
      height: 76vh;
      /* padding-top: 10px; */
      margin-top: 10px;
      overflow: auto;
    }
    .card {
      width: 95%;
      height: 200px;
      background: #ffffff;
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
      border-radius: 8px 8px 8px 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      opacity: 1;
      margin: 20px auto;
      .card_bh {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        .card_content_top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-left: 10px;
          .card_left {
            display: flex;
          }
          .card_right {
            display: flex;
            div {
              width: 145px;
              height: 47px;
              border-radius: 4px 4px 4px 4px;
              opacity: 1;
              border: 2px solid #1890ff;
              line-height: 47px;
              text-align: center;
              font-size: 18px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #1890ff;
              margin-right: 10px;
              cursor: pointer;
            }
          }
          .top_title {
            font-size: 24px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            color: #333333;
          }
          .top_right {
            margin-left: 30px;
            width: 113px;
            height: 33px;
            background: #1795ff;
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            font-size: 18px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            line-height: 33px;
          }
        }
        .card_details {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0 40px 0 10px;
          font-size: 18px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          .every {
            display: flex;
            align-items: center;
            i {
              color: #1890ff;
            }
          }
        }
      }
      .card_content {
        margin-left: 10px;
        height: 180px;
        opacity: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        span {
          color: #ccc;
        }
      }
      .card_content_center {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        margin-right: 30px;
      }
    }
    .card_content_bottom {
      display: flex;
      .right_content {
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
    }
    .card_right {
      margin-right: 30px;
    }
  }
  .personal_box {
    width: 100%;
    display: flex;
    justify-content: center;
    .box_personal_content {
      width: 70%;
    }
  }
  .Personal {
    width: 40%;
  }

  ::v-deep .Personal .el-input__inner {
    width: 100%;
    border: 0;
    border-bottom: #ccc 1px solid;
    border-radius: 0;
    padding: 0;
  }
  ::v-deep.el-input.is-disabled .el-input__inner {
    background-color: #fff;
    color: #000000;
  }
}
.photo {
  border-radius: 50%;
  width: 100px;
}
.fromsBox {
  overflow: auto;
  padding: 10px;
}
.cion {
  height: 100%;
}
.fromsBoxs {
  height: 100%;
  overflow: auto;
  padding: 10px;
}
//
</style>


// WEBPACK FOOTER //
// src/view/index/xiaoxi.vue